/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { DISPLAY_SNAPSHOT_IMAGE_FRAGMENT } from './DisplaySnapshotImageFragment'

export const DISPLAY_SNAPSHOT_FRAGMENT = gql`
  fragment DisplaySnapshot on DisplaySnapshot {
    id
    created
    captureTime
    type
    display {
      id
      name
      order
      store {
        id
      }
      averageDepth
    }
    user {
      id
      firstName
      lastName
      email
      profileImage {
        url
      }
    }
    images {
      ...DisplaySnapshotImage
    }
    score {
      score
    }
    planogramSegmentShapedFacings {
      id
      upc
    }
    complianceInfo {
      planogramUpcSet
      detectedUpcSet
      intersectionUpcSet
      unionUpcSet
      missingFacings {
        id
        upc
      }
      extraBoundingBoxes {
        id
        classifiedLabel
      }
      flexExtraBoundingBoxes {
        id
        classifiedLabel
      }
      nonFlexExtraBoundingBoxes {
        id
        classifiedLabel
      }
    }
  }
  ${DISPLAY_SNAPSHOT_IMAGE_FRAGMENT}
`
